module.exports = __webpack_public_path__ + "public/img/yibiaopan_lv_19.9f9d6474.png";